module.exports = require("lru-cache-promise");


//////////////////
// WEBPACK FOOTER
// external "lru-cache-promise"
// module id = 14
// module chunks = 0